import React from "react";
import HeroCareer from "../component/HeroCareer";

const Career = () => {
    return (
        <div style={{ backgroundColor: "rgb(19, 37, 48)" }}>
            {/* HERO */}
            <HeroCareer />

            {/* INTRO SECTION */}
            <section className="container text-light text-center pt-5">
                <h2 className="fw-bold mb-4">
                    Become part of a fast-growing automotive leader in the UAE!
                </h2>

                <p className="career-text">
                    At Ghayar Auto Spare Parts, we believe our people are our greatest
                    strength. We offer a supportive, inclusive, and growth-driven
                    workplace where talent is valued, ideas are encouraged, and
                    achievements are recognized.
                </p>

                <p className="career-text">
                    Working at Ghayar means being part of a collaborative team with strong
                    industry expertise, modern processes, and a clear vision for the
                    future of the automotive aftermarket. We invest in our employees
                    through continuous learning, career development opportunities, and
                    exposure to a dynamic and fast-evolving market.
                </p>

                <p className="career-text">
                    Our culture is built on respect, integrity, teamwork, innovation, and
                    accountability. We promote work-life balance, open communication, and
                    an environment where everyone feels empowered to contribute and grow.
                    As we continue to expand across the UAE and beyond, we offer our
                    employees stability, long-term career prospects, and the opportunity
                    to grow alongside the business.
                </p>

                <p className="career-text">
                    If you’re passionate about the automotive industry and looking for a
                    place where your work truly matters, Ghayar Auto Spare Parts is a great
                    place to build your future.
                </p>
            </section>

            {/* DIVIDER */}
            {/* <div className="container">
                <hr className="career-divider" />
            </div> */}

            {/* JOB LISTING */}
            <section className="career-section-b2b container text-center text-light" id="B2B">
                <h5 className="career-job-title" onClick={() => window.open('/pdf/hiring_v008.pdf')}>
                    B2B Sales Specialist – Automotive Industry
                </h5>
                <p className="career-job-desc">
                    Proven experience in B2B sales, preferably within the automotive or
                    related industries. <strong>Ajman Location.</strong>
                </p>
            </section>

            {/* DIVIDER */}
            <div className="container">
                <hr className="career-divider" />
            </div>

        </div>
    );
};

export default Career;
